import { createContext } from 'react';

export const LinesContext =  createContext ();